export const GET_DATA = 'uptain/GET_DATA';
export const SAVE_DATA = 'uptain/SAVE_DATA';
export const TEST_DATA = 'uptain/TEST_DATA';
export const DELETE_DATA = 'uptain/DELETE_DATA';
export const ADD_DATA = 'uptain/ADD_DATA';
export const GET_DATA_LIST = 'uptain/GET_DATA_LIST';
